(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-desktop-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
    if (!desktopQuery.matches) return;

    const syncJudgeMeProof = () => {
      const providerData = document.querySelector('.jdgm-all-reviews-widget-v2025-data-json');
      const proof = document.querySelector('.ae-desktop-home__proof');
      if (!providerData || !proof) return false;

      try {
        const data = JSON.parse(providerData.textContent);
        const aggregateRating = proof.querySelector('[data-ae-review-rating]');
        const aggregateCount = proof.querySelector('[data-ae-review-count]');
        if (aggregateRating && data.average_rating) {
          aggregateRating.textContent = Number(data.average_rating).toFixed(2);
        }
        if (aggregateCount && data.number_of_reviews) {
          aggregateCount.textContent = `${Number(data.number_of_reviews).toLocaleString('en-GB')} customer reviews`;
        }
        const routeRating = document.querySelector('[data-ae-route-review-rating]');
        const routeCount = document.querySelector('[data-ae-route-review-count]');
        if (routeRating && data.average_rating) {
          routeRating.textContent = Number(data.average_rating).toFixed(2);
        }
        if (routeCount && data.number_of_reviews) {
          routeCount.textContent = Number(data.number_of_reviews).toLocaleString('en-GB');
        }

        const evidenceTerms = /\b(plant|plants|healthy|health|condition|quality|fresh|root|roots|leaf|leaves|pack|packed|packing|packaging|deliver|delivered|delivery|arrived|arrival)\b/gi;
        const preferredReviewIds = [
          'fbaf678e-fbe4-45d0-8383-a57d9dd9aab1',
          '9e1b6495-9934-4824-a422-c99fa6f4a9c4'
        ];
        const reviewPool = [...(data.all_reviews || []), ...(data.shop_reviews || [])];
        const uniqueReviews = [...new Map(reviewPool.filter((review) => review.uuid).map((review) => [review.uuid, review])).values()]
          .map((review, index) => {
            const name = (review.reviewer_name || '').trim();
            const body = (review.body || '').trim();
            const termMatches = body.match(evidenceTerms) || [];
            return {
              ...review,
              _index: index,
              _name: name,
              _body: body,
              _evidenceScore: (termMatches.length * 20) + Math.min(body.length, 240) / 20 + Number(review.rating || 0)
            };
          });
        const isUsableReview = (review) => review && review.verified_buyer && Number(review.rating) === 5 && review._name && !/^anonymous$/i.test(review._name) && review._body.length >= 45;
        const preferredReviews = preferredReviewIds
          .map((uuid) => uniqueReviews.find((review) => review.uuid === uuid))
          .filter(isUsableReview);
        const seenReviewers = new Set(preferredReviews.map((review) => review._name.toLowerCase()));
        const fallbackReviews = uniqueReviews
          .filter((review) => isUsableReview(review) && review._evidenceScore >= 25 && !preferredReviewIds.includes(review.uuid))
          .sort((a, b) => b._evidenceScore - a._evidenceScore || a._index - b._index)
          .filter((review) => {
            const reviewerKey = review._name.toLowerCase();
            if (seenReviewers.has(reviewerKey)) return false;
            seenReviewers.add(reviewerKey);
            return true;
          });
        const reviews = [...preferredReviews, ...fallbackReviews].slice(0, 2);

        proof.querySelectorAll('[data-ae-review-slot]').forEach((slot, index) => {
          const review = reviews[index];
          if (!review) {
            slot.hidden = true;
            return;
          }
          const rating = Math.max(1, Math.min(5, Math.round(Number(review.rating))));
          const stars = slot.querySelector('[data-ae-review-stars]');
          stars.textContent = `${'★'.repeat(rating)}${'☆'.repeat(5 - rating)}`;
          stars.setAttribute('aria-label', `${rating} out of 5 stars`);
          slot.querySelector('[data-ae-review-quote]').textContent = review._body;
          slot.querySelector('[data-ae-review-name]').textContent = review._name;
          slot.hidden = false;
        });
        return true;
      } catch (error) {
        return false;
      }
    };

    if (!syncJudgeMeProof()) {
      let attempts = 0;
      const providerTimer = window.setInterval(() => {
        attempts += 1;
        if (syncJudgeMeProof() || attempts >= 20) window.clearInterval(providerTimer);
      }, 500);
    }

    const measurementRoot = document.querySelector('.ae-desktop-home');
    if (!measurementRoot || measurementRoot.dataset.aeMeasurementBound === 'true') return;
    measurementRoot.dataset.aeMeasurementBound = 'true';

    const measurementVersion = 'desktop_home_v2';
    const measurementDebug = new URLSearchParams(window.location.search).get('ae_measurement_debug') === '1';
    const cleanValue = (value, maxLength = 100) => String(value || '').trim().slice(0, maxLength);
    const destinationPath = (element) => {
      const href = element?.getAttribute?.('href');
      if (!href) return '';
      try {
        const url = new URL(href, window.location.origin);
        return `${url.pathname}${url.hash || ''}`.slice(0, 120);
      } catch (error) {
        return '';
      }
    };
    const safeSearchTerm = (value) => {
      const term = cleanValue(value, 80);
      if (!term) return '';
      if (/@/.test(term) || /\d{7,}/.test(term)) return '[redacted]';
      return term;
    };
    const elementParameters = (element) => {
      const card = element?.closest?.('.ae-desktop-home__product-card');
      const source = card || element;
      const priceCents = Number(source?.dataset?.aePriceCents || 0);
      return {
        module_name: cleanValue(element?.dataset?.aeModule),
        action_name: cleanValue(element?.dataset?.aeActionName),
        cta_name: cleanValue(element?.dataset?.aeCtaName),
        entry_source: cleanValue(element?.dataset?.aeEntrySource),
        route_name: cleanValue(element?.dataset?.aeRouteName),
        item_name: cleanValue(source?.dataset?.aeItemName),
        product_id: cleanValue(source?.dataset?.aeProductId),
        product_handle: cleanValue(source?.dataset?.aeProductHandle),
        variant_id: cleanValue(element?.dataset?.aeVariantId),
        item_position: Number(source?.dataset?.aePosition || element?.dataset?.aePosition || 0) || undefined,
        value: priceCents > 0 ? priceCents / 100 : undefined,
        currency: priceCents > 0 ? cleanValue(measurementRoot.dataset.aeCurrency, 3) : undefined,
        destination_path: destinationPath(element)
      };
    };
    const compactParameters = (parameters) => Object.fromEntries(
      Object.entries(parameters).filter(([, value]) => value !== '' && value !== undefined && value !== null)
    );
    const publishMeasurement = (eventName, parameters = {}) => {
      if (!desktopQuery.matches || !eventName) return;
      const payload = compactParameters({
        page_version: measurementVersion,
        device_category: 'desktop',
        page_type: 'homepage',
        page_path: window.location.pathname,
        debug_mode: measurementDebug || undefined,
        ...parameters
      });

      if (measurementDebug) {
        console.debug('[AE desktop measurement]', eventName, JSON.stringify(payload));
      }

      try {
        window.Shopify = window.Shopify || {};
        window.Shopify.analytics = window.Shopify.analytics || {};
        window.Shopify.analytics.replayQueue = window.Shopify.analytics.replayQueue || [];
        window.Shopify.analytics.publish = window.Shopify.analytics.publish || function(name, data) {
          window.Shopify.analytics.replayQueue.push([name, data]);
        };
        window.Shopify.analytics.publish(eventName, payload);
      } catch (error) {}
      try {
        if (!/(_view|_exposure)$/.test(eventName)) {
          window.sessionStorage.setItem('ae_desktop_home_last_interaction', JSON.stringify({
            event_name: eventName,
            route_name: payload.route_name || '',
            product_handle: payload.product_handle || '',
            timestamp: Date.now()
          }));
        }
      } catch (error) {}
    };

    const handleMeasurementClick = (event, providedElement = null) => {
      const boundElement = providedElement && providedElement.matches?.('[data-ae-event]')
        ? providedElement
        : null;
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      const element = boundElement
        || path.find((node) => node && node.matches?.('[data-ae-event]'))
        || event.target.closest?.('[data-ae-event]');
      if (!element) return;
      const anchor = element.matches?.('a[href]') ? element : element.closest?.('a[href]');
      const shouldDelayNavigation = event.type === 'click' && Boolean(
        anchor
        && event.button === 0
        && !event.metaKey
        && !event.ctrlKey
        && !event.shiftKey
        && !event.altKey
        && (!anchor.target || anchor.target === '_self')
        && anchor.origin === window.location.origin
      );
      if (shouldDelayNavigation) event.preventDefault();
      const parameters = elementParameters(element);
      publishMeasurement(element.dataset.aeEvent, parameters);
      if (element.dataset.aeSecondaryEvent) {
        publishMeasurement(element.dataset.aeSecondaryEvent, parameters);
      }
      if (shouldDelayNavigation) {
        window.setTimeout(() => window.location.assign(anchor.href), 140);
      }
    };
    measurementRoot.querySelectorAll('[data-ae-event]').forEach((element) => {
      element.addEventListener('click', (event) => handleMeasurementClick(event, element), true);
    });
    const publishQuickAddMeasurement = (form) => {
      if (!form.matches?.('.ae-desktop-home__quick-add')) return;
      if (form.dataset.aeQuickAddMeasurementPending === 'true') return;
      form.dataset.aeQuickAddMeasurementPending = 'true';
      const card = form.closest('.ae-desktop-home__product-card');
      const parameters = elementParameters(card);
      parameters.module_name = 'best_sellers';
      parameters.action_name = 'add_to_cart';
      parameters.variant_id = cleanValue(form.querySelector('[name="id"]')?.value);
      publishMeasurement('ae_desktop_home_add_to_cart', parameters);
    };

    measurementRoot.addEventListener('click', (event) => {
      const submitButton = event.target.closest?.('.ae-desktop-home__quick-add button[type="submit"], .ae-desktop-home__quick-add input[type="submit"]');
      if (!submitButton) return;
      publishQuickAddMeasurement(submitButton.closest('form'));
    }, true);

    measurementRoot.addEventListener('submit', (event) => {
      publishQuickAddMeasurement(event.target);
    });

    const publishSearchMeasurement = (form) => {
      if (!desktopQuery.matches || !form?.matches?.('form[role="search"], form[action*="/search"]')) return;
      if (!form.getClientRects().length || form.dataset.aeSearchMeasurementPending === 'true') return;
      const input = form.querySelector('input[name="q"], input[type="search"]');
      const rawTerm = cleanValue(input?.value, 200);
      form.dataset.aeSearchMeasurementPending = 'true';
      publishMeasurement('ae_desktop_search_submit', {
        module_name: 'desktop_header',
        search_location: 'desktop_header',
        search_term: safeSearchTerm(rawTerm),
        search_term_length: rawTerm.length,
        destination_path: '/search'
      });
    };

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || !event.target.matches?.('input[name="q"], input[type="search"]')) return;
      publishSearchMeasurement(event.target.closest('form'));
    }, true);

    document.addEventListener('click', (event) => {
      const submitButton = event.target.closest?.('button[type="submit"], input[type="submit"]');
      if (!submitButton) return;
      publishSearchMeasurement(submitButton.closest('form'));
    }, true);

    document.addEventListener('submit', (event) => {
      publishSearchMeasurement(event.target);
    }, true);

    const proofSection = measurementRoot.querySelector('.ae-desktop-home__proof');
    if (proofSection && 'IntersectionObserver' in window) {
      let proofMeasured = false;
      const proofObserver = new IntersectionObserver((entries) => {
        if (proofMeasured || !entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.4)) return;
        proofMeasured = true;
        publishMeasurement('ae_desktop_review_exposure', { module_name: 'review_proof' });
        proofObserver.disconnect();
      }, { threshold: [0.4] });
      proofObserver.observe(proofSection);
    }

    publishMeasurement('ae_desktop_home_view', { module_name: 'homepage' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-mobile-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.ae-home');
    if (!root || root.dataset.aeCroMonitoring === 'loaded') return;

    const deviceType = () => window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)').matches ? 'desktop' : 'mobile';
    if (deviceType() === 'desktop') return;
    root.dataset.aeCroMonitoring = 'loaded';
    const sendEvent = (eventName, details = {}) => {
      const payload = {
        event_category: 'homepage_cro',
        page_path: window.location.pathname,
        device_type: deviceType(),
        ...details
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...payload });
      document.documentElement.setAttribute('data-ae-home-last-event', eventName);

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      }
    };

    root.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a[data-ae-home-action]');
      if (!link || !root.contains(link)) return;

      sendEvent('ae_home_link_clicked', {
        action_name: link.dataset.aeHomeAction,
        destination: link.getAttribute('href') || '',
        product_handle: link.dataset.aeProductHandle || ''
      });
    }, true);

    root.querySelectorAll('.ae-home__best').forEach(section => {
      const rail = section.querySelector('.ae-home__product-rail');
      const dots = section.querySelectorAll('.ae-home__carousel-cue span');
      if (!rail || dots.length < 2) return;

      let frame;
      const updateActiveDot = () => {
        frame = undefined;
        const maxScroll = rail.scrollWidth - rail.clientWidth;
        const progress = maxScroll > 0 ? rail.scrollLeft / maxScroll : 0;
        const activeIndex = Math.min(dots.length - 1, Math.round(progress * (dots.length - 1)));

        dots.forEach((dot, index) => dot.classList.toggle('is-current', index === activeIndex));
      };

      rail.addEventListener('scroll', () => {
        if (!frame) frame = window.requestAnimationFrame(updateActiveDot);
      }, { passive: true });
      window.addEventListener('resize', updateActiveDot);
      updateActiveDot();
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || entry.target.dataset.aeHomeViewed === 'true') return;
        entry.target.dataset.aeHomeViewed = 'true';
        observer.unobserve(entry.target);
        sendEvent('ae_home_section_viewed', { section_name: entry.target.dataset.aeHomeSection });
      });
    }, { threshold: 0.25 });

    root.querySelectorAll('[data-ae-home-section]').forEach(section => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  (() => {
    const desktopQuery = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
    const header = document.querySelector('.shopify-section-header .header');
    if (!header) return;

    const lockedNavigation = [
      { label: 'Aquarium Plants' },
      { label: 'Mixed Boxes' },
      { label: 'Plants on Wood', href: '/collections/plants-on-wood', simple: true },
      { label: 'Plant Care' },
      { label: 'Aquascaping' },
      { label: 'Subscribe & Save', href: '/collections/subscribe-save', simple: true },
      { label: 'Advice', href: '/blogs/the-aquarium-plant-blog', simple: true },
      { label: 'Offers', href: '/collections/on-sale', simple: true }
    ];

    const syncNavigation = (isDesktop) => {
      const menuItems = header.querySelectorAll('.header__inline-menu .list-menu--inline > li');
      menuItems.forEach((item, index) => {
        const link = item.querySelector(':scope > * > .header__menu-item--top');
        const label = link?.querySelector('.label');
        if (!link || !label) return;

        if (!link.dataset.aeOriginalLabel) {
          link.dataset.aeOriginalLabel = label.textContent.trim();
          link.dataset.aeOriginalHref = link.getAttribute('href') || '';
        }

        const lockedItem = lockedNavigation[index];
        if (isDesktop && lockedItem) {
          label.textContent = lockedItem.label;
          if (lockedItem.href) link.setAttribute('href', lockedItem.href);
          item.classList.toggle('ae-desktop-locked-simple', Boolean(lockedItem.simple));
          item.hidden = false;
        } else {
          label.textContent = link.dataset.aeOriginalLabel;
          link.setAttribute('href', link.dataset.aeOriginalHref);
          item.classList.remove('ae-desktop-locked-simple');
          item.hidden = false;
        }
      });
    };

    const syncActionLabels = (isDesktop) => {
      header.querySelectorAll('.ae-desktop-action-label').forEach((label) => label.remove());
      if (!isDesktop) return;

      [
        [header.querySelector('cart-drawer summary, a.header__icon--cart'), 'Cart']
      ].forEach(([target, text]) => {
        if (!target) return;
        const label = document.createElement('span');
        label.className = 'ae-desktop-action-label';
        label.setAttribute('aria-hidden', 'true');
        label.textContent = text;
        target.appendChild(label);
      });
    };

    const applyDesktopHeader = () => {
      syncNavigation(desktopQuery.matches);
      syncActionLabels(desktopQuery.matches);
    };

    applyDesktopHeader();
    desktopQuery.addEventListener?.('change', applyDesktopHeader);

    const plantFinder = header.querySelector('.ae-desktop-plant-finder');
    plantFinder?.addEventListener('click', () => {
      if (!desktopQuery.matches) return;
      const payload = {
        page_version: 'wow5-final',
        device_category: 'desktop',
        page_type: document.body.classList.contains('template-index') ? 'homepage' : 'sitewide',
        page_path: window.location.pathname,
        module_name: 'desktop_header',
        action_name: 'header_utility_link',
        entry_source: 'header_utility',
        destination_path: '/pages/plant-finder'
      };

      try {
        window.Shopify = window.Shopify || {};
        window.Shopify.analytics = window.Shopify.analytics || {};
        window.Shopify.analytics.replayQueue = window.Shopify.analytics.replayQueue || [];
        window.Shopify.analytics.publish = window.Shopify.analytics.publish || function(name, data) {
          window.Shopify.analytics.replayQueue.push([name, data]);
        };
        window.Shopify.analytics.publish('ae_desktop_plant_finder_start', payload);
      } catch (error) {}
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
